import { Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getActiveAuthToken } from 'utils/getActiveAuthHeaders';
import { I18n } from 'utils/i18n';
import redirect from 'utils/redirect';

const NotFoundScene = () => {
  const hasSession = useSelector(state => Boolean(getActiveAuthToken(state.auth)?.hash));

  useEffect(() => {
    if (!hasSession) {
      redirect(`/auth/login?returnUrl=${encodeURIComponent(window.location.href)}`);
    }
  }, [hasSession]);

  if (!hasSession) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography component="div">
        <p>{I18n.t('NotFoundScene.title')}</p>
        <a
          href="/"
          style={{
            textAlign: 'center',
            color: '#313ad4',
          }}
        >
          {I18n.t('NotFoundScene.goHome')}
        </a>
      </Typography>
    </div>
  );
};

export default NotFoundScene;
